import { render, staticRenderFns } from "./TripNews.vue?vue&type=template&id=50884ac3&scoped=true&lang=html&"
import script from "./TripNews.vue?vue&type=script&lang=js&"
export * from "./TripNews.vue?vue&type=script&lang=js&"
import style0 from "./TripNews.vue?vue&type=style&index=0&id=50884ac3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50884ac3",
  null
  
)

export default component.exports